const _ = require("lodash");
const Font = require("../../util/Font");
const LineLayout = require("../LineLayout");
const {getLineWidth} = require("../util/RenderHelpers");
const ColorUtil = require("../../util/ColorUtil");
const colors = ColorUtil.getDiagramColors();

const exampleBlockParser = function(ps) {
	let children = ps.parseNonmath(ps);
	// Since changing this from inline to multiline wrapped, we want to ignore
	// all first-line linebreaks to avoid changing this on problem entry side
	if (children[0].type === "lineBreak") {
		children = children.slice(1);
	}
	return [
		{
			type: "exampleBlock",
			children: [{type: "wrapping", children}],
		},
	];
};

const exampleBlockNode = {
	draw(rc, x, y, node, measure) {
		const {
			fontInfo,
			top,
			bottom,
			text,
			pad,
			spacing,
			textMeasure,
			contentMeasure,
			contentIsBlock,
		} = measure;
		const height = top + bottom;
		const context = rc.context;

		context.save();
		context.font = Font.fromInfo(fontInfo);
		rc.drawNode(rc, x, y, text);
		context
			.bp()
			.M(textMeasure.width + pad + x, y - top)
			.v(height)
			.stroke(colors.defaultblack);
		context.restore();
		if (contentIsBlock) {
			LineLayout.drawInline(
				rc,
				x + textMeasure.width + spacing,
				y,
				node.children[0].children,
				{blocksInLine: true}
			);
		} else {
			rc.drawNode(
				rc,
				x + textMeasure.width + spacing,
				y - contentMeasure.height / 2,
				node.children[0]
			);
		}
	},
	measure(rc, fontInfo, props, node) {
		const pad = fontInfo.size / 2;
		const text = {type: "bold", children: [{type: "text", text: "EXAMPLE"}]};
		// space between example line and content
		const spacing = 2 * pad + getLineWidth(rc, fontInfo);
		const textMeasure = rc.measureNode(rc, fontInfo, props, text);
		const contentIsBlock = rc.isBlockNode(node.children[0].children[0]);
		const contentMeasure = rc.measureNode(
			rc,
			fontInfo,
			_.extend({}, props, {
				maxLineWidth: props.maxLineWidth - textMeasure.width - spacing,
			}),
			node.children[0]
		);
		const height = Math.max(
			contentMeasure.height,
			(textMeasure.top + textMeasure.bottom) * 1.5
		);
		return {
			width: textMeasure.width + contentMeasure.width + spacing,
			top: height / 2,
			bottom: height / 2,
			fontInfo,
			textMeasure,
			contentMeasure,
			contentIsBlock,
			text,
			pad,
			spacing,
		};
	},
	readAloud: function(node, context) {
		const exampleText = context.readAloudBatexChildren(node, context.raProps);
		return exampleText ? "Example,, " + exampleText : null;
		/*
			If you need to throw an error...

			Include BatexAloud and use BatexAloud.logErrorAndGetReturnValue
		*/
	},
};

module.exports = {
	parsers: {
		nonmathEnvironments: {
			exampleBlock: exampleBlockParser,
		},
	},
	nodes: {
		exampleBlock: exampleBlockNode,
	},
};
